import { Contact } from '@api/generated/graphql';
import ContactMethodLink from '@components/ContactMethodLink/ContactMethodLink';
import { TableCellProps } from '@servicetitan/design-system';

/**
 * Renders a table cell containing the value of a contact method as a link.
 *
 */
const ContactMethodValueCell = ({
  colSpan,
  className,
  ...restProps
}: TableCellProps) => {
  const contact = restProps.dataItem as Contact;

  return (
    <td colSpan={colSpan} className={className}>
      <ContactMethodLink contact={contact} />
    </td>
  );
};

export default ContactMethodValueCell;
